// extracted by mini-css-extract-plugin
export var form = "_4d-0";